const schema = {
    // INCOMPLETE AND NOT FINAL
    name: 'string',
};

export default schema;
